<template>
	<div id="listStyle">
		<Form ref="formValidate" :model="formValidate" :label-width="85" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" ghost @click="addComplaint">新增投诉</Button>
				</FormItem>
				</Col>

				<Col :span="6">
				<FormItem label="用户id：" prop="userLoginId" label-for="userLoginId">
					<Input v-model="formValidate.userLoginId" placeholder="请输入" element-id="userLoginId" />
				</FormItem>
				</Col>


				<Col :span="6">
				<FormItem label="投诉类型" prop="complaintType">
					<Select v-model="formValidate.complaintType" placeholder="请选择" :label-in-value="true">
						<Option v-for="(item,index)  in complaintTypes" :value="item.complaintType"
							:label="item.complaintTypeName" :key="index">{{item.complaintTypeName}}
						</Option>
					</Select>
				</FormItem>
				</Col>
				</Col>

				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<List border header="投诉信息" size="large">
			<ListItem v-for="(item, index) in complaintList" :key="index">
				<ListItemMeta :avatar="getImgUrl(item.iconPath)"
					:title="item.complaintTypeName+'------'+item.otherName+'------'+item.doResult" />
				<div style="cursor:pointer;  " @click="showComplaint(item.complaintId)">
					<a>
						<Icon type="ios-eye" />投诉详情--- {{ item.userLoginId }} 发表于
						{{dateFormat(new Date(item.createTime))}}
					</a>
				</div>
			</ListItem>

			<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage"
				show-total show-elevator next-text="下一页" />
		</list>

	</div>
</template>

<script>
	import {
		complaintlist,
		complaintTypelist
	} from '@/network/index.js';



	//分页的初始参数
	let paramter = {
		page: 1,
		pagesize: 20,
		ispage: 'Y',
		complaintType: null,
		userLoginId: null,
	};


	export default {
		name: "ComplaintList",

		data() {

			return {
				complaintList: [],
				complaintTypes: [],
				formValidate: {
					complaintType: '',
					userLoginId: '',
				},
				pageTotal: 0,
				pageNum: 1,
				pageSize: 5,

			}
		},
		created() {
			this.dataListInit();

			complaintTypelist().then(res => {
					// console.log(res);
					// console.log(''+res.data.obj.length+'');
					for (var i = 0; i < res.data.obj.dataList.length; i++) {
						this.complaintTypes.push({
							complaintType: res.data.obj.dataList[i].complaintType,
							complaintTypeName: res.data.obj.dataList[i].complaintTypeName
						});


					}

				})
				.catch(error => {});

		},
		computed: {

		},


		methods: {
			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;
				// console.log("11111this.searchValue:"+this.searchValue)
				this.dataListInit()
			},


			dataListInit() {

				complaintlist(paramter).then(res => {
						//debugger
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;

						this.complaintList = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.complaintList.push({
								complaintId: res.data.obj.dataList[i].complaintId,
								userLoginId: res.data.obj.dataList[i].userLoginId,
								otherName: res.data.obj.dataList[i].otherName,
								iconPath: res.data.obj.dataList[i].iconPath,
								complaintType: res.data.obj.dataList[i].complaintType,
								complaintTypeName: res.data.obj.dataList[i].complaintTypeName,
								complaintReason: res.data.obj.dataList[i].complaintReason,
								createTime: res.data.obj.dataList[i].createTime,
								doResult: res.data.obj.dataList[i].doResult == '0' ? '【未处理】' : '【已处理】',


							})
						}


					})
					.catch(error => {});

			},

			itemClick() {
				this.$router.replace(this.path)
			},

			// 动态获取头像图片
			getImgUrl(picName) {
				//默认图标
				// debugger


				if (picName == 'data:image/png;base64,init') {
					return require("@/assets/image/element/headPhoto/1.png");
				} else {
					//base64图标
					return picName;
				}
			},

			//查询提交
			handleSubmit() {
				if (this.formValidate.complaintType != null && this.formValidate.complaintType != '') {
					paramter.complaintType = this.formValidate.complaintType
				}
				if (this.formValidate.userLoginId != null && this.formValidate.userLoginId != '') {
					paramter.userLoginId = this.formValidate.userLoginId
				}
				complaintlist(paramter).then(res => {
						//debugger
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;

						this.complaintList = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.complaintList.push({
								complaintId: res.data.obj.dataList[i].complaintId,
								userLoginId: res.data.obj.dataList[i].userLoginId,
								otherName: res.data.obj.dataList[i].otherName,
								iconPath: res.data.obj.dataList[i].iconPath,
								complaintType: res.data.obj.dataList[i].complaintType,
								complaintTypeName: res.data.obj.dataList[i].complaintTypeName,
								complaintReason: res.data.obj.dataList[i].complaintReason,
								createTime: res.data.obj.dataList[i].createTime,
								doResult: res.data.obj.dataList[i].doResult == '0' ? '【未处理】' : '【已处理】',


							})
						}
					})
					.catch(error => {});


			},

            //新增投诉
			addComplaint() {
				this.$router.push('/complaintSend')
			},
			//显示资源
			showComplaint(val) {
				//	debugger;
				let complaintId = val; //获取value
				//	this.$router.push('/resourceDownload')

				//push如果是传的对象的形式 就可以传递参数
				//params 传参
				//push里面还可以传入name，  name是路由名字index.js里定义的
				//params传参只能用name   参数不会在地址栏里  刷新后参数会消失
				this.$router.push({
					name: 'complaintSendDo',
					params: {
						//前面的name可以随便取
						complaintId: complaintId

					}
				})

			},
			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			//时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
			dateFormat(time) {
				var date = new Date(time);
				var year = date.getFullYear();
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				// 拼接
				return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}
 
	#dayCount {

		height: 30px; //设置高度
		font-size: 15px; //设置字体大小
		color: #2d8cf0;
		//	position: relative;
		font-family: "PingFang SC";
		padding: 7px
	}

	#page {
		//float:right 
		text-align: right
	}

	.underline {
		display: inline-block;
		position: relative;
		line-height: 2;
	}

	.underline::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		transform: scaleX(0);
		width: 100%;
		height: 2px;
		transform-origin: 50% bottom;
		background: #2d8cf0;
		transition: transform 1s;
	}

	.underline:hover::after {
		transform: scaleX(1);
		transition: transform 1s;
	}
</style>
